export default __webpack_public_path__ + "static/media/TL06.1.b5425f30.mp3";